import styled from "styled-components";
import {VideoComponent} from "../../../../live-streaming-tile/video-common-components/video-component/video.component";

export const VideoSlidesFilterItemPreviewPlayerDefaultBox = styled(VideoComponent)`
    > video {
        object-fit: unset;
    }
`